/**
 * AdminDashboardRpcClient — AtomRpc integration for the global Dashboard
 * cockpit (CLA-410). Backs the two read-only aggregate endpoints powering the
 * cockpit: `admin/dashboard/summary` (Pipeline / Fleet / Revenue counters) and
 * `admin/dashboard/attention` (the unified Needs Attention feed).
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminDashboardRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminDashboardRpcClient extends AtomRpc.Tag<AdminDashboardRpcClient>()(
  "AdminDashboardRpcClient",
  {
    group: AdminDashboardRpcs,
    protocol: makeRpcClientLayer(AdminDashboardRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
